// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartTitleStyles } from "@conklin/App/Widgets/Cart/CartTitle";
import { css } from "styled-components";

cartTitleStyles.container = {
    css: css`
        display: flex;
        align-items: baseline;
    `,
};

cartTitleStyles.pageTitle = {
    variant: "h1",
    css: css`
        margin-bottom: 0;
        margin-right: 24px;
        /* Override OOTB h1 print style */
        @media print {
            font-size: 24px !important;
        }
    `,
};
cartTitleStyles.itemCountText = {
    variant: "h5",
    forwardAs: "h2",
    css: css`
        margin-bottom: 0;
    `,
};
